var fileUploadTileJS = (function () {

    var initialized = false;
    var fileCount = 0;
    var fileInfoUploadQueue = [];
    var uploadCardContent;
    var isUploading = false;

    function addTofileInfoUploadQueue(file, fileContainer) {
        fileContainer.parent(1).find('.file-name')[0].textContent = file.name;
        fileContainer.parent().parent().removeClass('upload-contents-hidden');
        var cardContent = fileContainer.closest('.submit-docs-card-content');
        //Open Collapsed Section
        if (!cardContent.find(".upload-collapse").first().hasClass("show")) {
            cardContent.find(".upload-collapse").first().collapse("show");
            cardContent.find(".no-docs").first().hide();
        }

        const error = validateFile(file);
        if (!error) {
            fileInfoUploadQueue.push({ file: file, fileContainer: fileContainer });
            if (!isUploading) {
                processFileUploads();
            }
        }
        else {
            const uploadContents = fileContainer.closest('.upload-contents');
            const containerId = uploadContents.attr("id");
            uploadContents.append(`<div class="submit-docs-tile-ext-error" id="file-error-${containerId}">${file.name} : ${error} </div>`);
        }
    }

    function processFileUploads() {
        if (fileInfoUploadQueue.length == 0) {
            isUploading = false;
            return;
        }

        isUploading = true;

        const fileToUpload = fileInfoUploadQueue.shift();
        const fileContainer = fileToUpload.fileContainer;
        var cardContent = fileContainer.closest('.submit-docs-card-content');
        var isProofOfLifeEvent = cardContent.hasClass('proof-of-life-event');

        const formData = new FormData();
        formData.append('file', fileToUpload.file, fileToUpload.file.name);
        formData.append('IsProofOfLifeEvent', isProofOfLifeEvent);
        if (!isProofOfLifeEvent) {
            var dependentId = cardContent.closest(".dependent").data("dependent-id");
            var documentType = cardContent.closest(".submit-docs-card-content").data("document-type");
            formData.append('DependentId', dependentId);
            formData.append('DocumentType', documentType);
        }

        var uploadContainer = fileContainer.closest('.upload-container');
        $.ajax({
            url: '/DocumentTile/SaveFile',
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function (result) {
                if (result) {
                    addFileToDom(isProofOfLifeEvent, result.Id, result.DocumentId, cardContent, uploadContainer);
                    if (isProofOfLifeEvent) {
                        sendEmailNotification(false, {
                            filenames: [fileToUpload.file.name]
                        });
                    }
                }

                processFileUploads();
            },
            error: function () {
                if (isProofOfLifeEvent) {
                    sendEmailNotification(true, {
                        filenames: [fileToUpload.file.name]
                    });
                }
                showErrorModal({
                    ErrorMessage: `Failed to upload file ${fileToUpload.file.name}. Please try again.`
                });
                processFileUploads();
            }
        });
    }

    // Params:
    //  isProofOfLifeEvent: when true, document is not associated with a dependent but instead used as proof of life event.
    //  id: the identity ID of the document association.
    //  documentId: the ID of the azure blob document url.
    //  cardContent: the card content element.
    //  uploadContainer: the upload container element.
    function addFileToDom(isProofOfLifeEvent, id, documentId, cardContent, uploadContainer) {
        uploadContainer.find(".document-uploading").closest(".document-uploading").remove();
        uploadContainer.data("document-id", documentId);
         
        if (!isProofOfLifeEvent) {
            uploadContainer.data("id", id);
            cardContent.addClass("completed");
            uploadContainer.find('.cancelUpload').removeClass('cancelUpload').addClass('deleteUpload');
            updateCompletionStatus(cardContent);
            updateCardSectionStatus(cardContent.closest(".dependent"));

            const splitDocument = documentId.split('^');
            const existingDocHtml = `<div class="select-document-container">
                <input type="radio" class="select-document" name="selectedDocument" id="${documentId}" value="${documentId}" 
                    data-is-pdf="${splitDocument[2] == Titania.Enums.DocumentTypeEnum.PDF ? 'True' : 'False' }"/>
                <label class="select-document-label" for="${documentId}">${splitDocument[splitDocument.length - 1]}</label>
                </div>`;
            $('#existingDocuments').append(existingDocHtml);
        }
        else {
            uploadContainer.find('.cancelUpload').removeClass('cancelUpload').addClass('deleteFileFromAzure');
        }
    }

    function attachExistingFileToDependent(documentId, fileContainer) {
        var splitDocument = documentId.split('^');
        fileContainer.parent(1).find('.file-name')[0].textContent = splitDocument[splitDocument.length - 1];
        fileContainer.parent().parent().removeClass('upload-contents-hidden');
        
        $("#addExistingDocumentModal").modal('hide');

        var cardContent = fileContainer.closest('.submit-docs-card-content');
        //Open Collapsed Section
        if (!cardContent.find(".upload-collapse").first().hasClass("show")) {
            cardContent.find(".upload-collapse").first().collapse("show");
            cardContent.find(".no-docs").first().hide();
        }

        var dependentId = cardContent.closest(".dependent").data("dependent-id");
        var documentType = cardContent.closest(".submit-docs-card-content").data("document-type");

        $.ajax({
            url: '/DocumentTile/AttachExistingFileToDependent',
            type: 'POST',
            data: { 'documentId': documentId, 'dependentId': dependentId, 'documentType': documentType },
            success: function (data) {
                cardContent.find(".document-uploading").removeClass("document-uploading");
                cardContent.addClass("completed");
                updateCompletionStatus(cardContent);
                updateCardSectionStatus(cardContent.closest(".dependent"));
                fileContainer.closest('.upload-container').data("document-id", documentId);
                fileContainer.closest('.upload-container').data("id", data.Id);
                fileContainer.closest('.upload-container').find('.cancelUpload').removeClass('cancelUpload').addClass('deleteUpload');
            }
        });
    }

    function deleteFile(uploadContainer) {
        var cardContent = uploadContainer.closest(".submit-docs-card-content");
        $(".transaction-loading, .loader").addClass("active");
        $.ajax({
            url: '/DocumentTile/DeleteUploadedDocument',
            type: 'POST',
            data:
            {
                'documentId': uploadContainer.data('documentId'),
                'relatedPersonObjectId': cardContent.closest(".dependent").data("dependent-id"),
                'documentType': cardContent.data("document-type"),
            },
            success: function () { 
                var dependent = cardContent.closest(".dependent"); 
                uploadContainer.closest('.upload-contents').remove();
                $(".transaction-loading, .loader").removeClass("active");

                if (cardContent.find(".upload-container").length == 0) {
                    cardContent.find(".upload-collapse").first().collapse("hide");
                    cardContent.find(".no-docs").first().show();
                }

                if (cardContent.find(".upload-container:not([data-document-approval-status='denied'])").length == 0) {
                    cardContent.removeClass('completed')
                    updateCompletionStatus(cardContent);
                    updateCardSectionStatus(dependent);
                }
            }
        });
    }

    function deleteFileFromAzure(uploadContainer) {
        $(".transaction-loading, .loader").addClass("active");
        $.ajax({
            url: '/DocumentTile/DeleteDocumentFromAzure',
            type: 'POST',
            data: { 'documentId': uploadContainer.data('document-id') },
            success: function (data) {
                uploadContainer.closest('.upload-contents').remove();
                $(".transaction-loading, .loader").removeClass("active");
            }
        });
    }

    function validateFile(file) {
        //keep this function in sync with stingray's participant document upload code found in participant-document-upload.component.ts
        const allowedFileExtensions = ['.bmp', '.doc', '.docx', '.heic', '.heif', '.jpeg', '.jpg', '.msg', '.pdf', '.png', '.tif', '.tiff', '.xls', '.xlsx'];
        var isValid = allowedFileExtensions.indexOf(file.name.substring(file.name.lastIndexOf('.')).toLowerCase()) != -1;
        if (!isValid) {
            return "Invalid File Extension."
        }
        const maxSizeInMB = 20;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
        if (file.size > maxSizeInBytes) {
            return `File size exceeds ${maxSizeInMB}MB`;
        }

        return null;
    }

    function updateCompletionStatus(cardContent) {
        var card = cardContent.closest(".submit-docs-card");
        var childrenCompleted = card.children(".completed").length;
        if (childrenCompleted > 0 && childrenCompleted >= parseInt(card.data("children-required"))) {
            card.addClass("completed");
            card.removeClass("incomplete");
        }
        else {
            card.addClass("incomplete");
            card.removeClass("completed");
        }
        var parentCard = card.parents(".submit-docs-card").first();
        if (parentCard.length > 0) {
            updateCompletionStatus(parentCard);
        }
    }

    function updateCardSectionStatus(dependent) {
        dependent.children('.section').each(function () {
            var card = $(this);
            var cardStatus = card.find('.submit-docs-card-status');
            var childrenCompleted = card.children(".completed").length;
            var childrenRequired = parseInt(card.data("children-required"));
            if (card.data('approval-status') != "approved" && card.data('approval-status') != "denied") {
                if (childrenCompleted >= childrenRequired) {
                    cardStatus.show();
                    cardStatus.html("Pending Approval");
                }
                else if (!dependent.hasClass("completed") && card.find('.upload-contents').length >= 1) {
                    cardStatus.show();
                    cardStatus.html(childrenRequired - childrenCompleted + " More Document" + ((childrenRequired - childrenCompleted) > 1 ? 's' : '') + " Required");
                }
                else {
                    cardStatus.hide();
                }
            }
        })
    }

    function getDocumentUrl(documentId) {

        return fetch('/DocumentTile/GetDocument', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ DocumentId: documentId })
        })
            .then(result => result.blob())
            .then(blob => URL.createObjectURL(blob));
    }

    function browserSupportsPDF() {
        return window.navigator.userAgent.indexOf("msie") == -1
            || hasActiveXObject('AcroPDF.PDF')
            || hasActiveXObject('PDF.PdfCtrl');
    }

    function hasActiveXObject(name) {
        try { return new ActiveXObject(name); } catch (e) { return false; }
    }

    function sendEmailNotification(didError, postData) {
        var navUrl = didError ? '/DocumentTile/_FileUploadError' : '/DocumentTile/_FileUploadComplete';
        $.ajax({
            url: navUrl,
            type: 'POST',
            data: postData
        });
    }

    return {
        Init: function () {
            if (initialized) {
                return;
            }

            $(".submit-docs-card-content").each(function () {
                if ($(this).find(".upload-contents").length == 0) {
                    $(this).find(".no-docs").first().show();
                }
                else {
                    $(this).find(".no-docs").first().hide();
                }
            });

            $(".upload-contents").each(function () {
                $(this).closest('.upload-collapse').addClass('show');
                updateCompletionStatus($(this));
            });

            $(".dependent").each(function () {
                updateCardSectionStatus($(this));
            })

            $('.attach-files-zone').on('dragover', function (event) {
                event.stopPropagation();
                event.preventDefault();
                event.originalEvent.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
            });

            $("body").on('dragover', function (event) {
                event.stopPropagation();
                event.preventDefault();
                event.originalEvent.dataTransfer.dropEffect = 'none';
            });

            $(document).on('change', '.select-document', function () {
                $(".transaction-loading, .loader").addClass("active");
                var isPdf = $(this).data('is-pdf') == "True";
                $('#fileNotSupported').hide();
                $('#textPreview').hide();
                getDocumentUrl($(this).val()).then((url) => {
                    if (isPdf) {
                        if (browserSupportsPDF()) {
                            $('#imagePreview').hide();
                            $('#pdfPreview').show();
                            $('#pdfPreview').attr('src', url);
                        }
                        else {
                            $('#file-not-supported').show();
                        }
                    }
                    else {
                        $('#pdfPreview').hide();
                        $('#imagePreview').show();
                        $('#imagePreview').attr('src', url);
                    }
                    $(".transaction-loading, .loader").removeClass("active");
                });
            });

            //Adding new documents
            $('.attach-files-zone').on('drop', function (event) {
                event.stopPropagation();
                event.preventDefault();
                //Grab upload container
                var cardContent = $(this).closest(".submit-docs-card-content");
                var myUploadDivs = cardContent.find('.upload-body').first();
                fileCount++;
                //Create an input control
                var newUploadControl = '<div class="upload-contents upload-contents-hidden" id="' + fileCount + '"><div class="row upload-container"><div class="col-6 file-browser"><span class="document-uploading"></span><span class="file-name">Browse for a file</span><i class="fas fa-trash-alt cancelUpload"></i></div><input type="file" class="soon-to-be-uploaded hiddenInput" accept=".bmp,.doc,.docx,.heic,.heif,.jpeg,.jpg,.msg,.pdf,.png,.tif,.tiff,.xls,.xlsx" /></div></div>';

                myUploadDivs.append(newUploadControl);
                var newFile = cardContent.find(".soon-to-be-uploaded").last();
                addTofileInfoUploadQueue(event.originalEvent.dataTransfer.files[0], newFile);
            });

            //Adding new documents
            $('.attach-files-zone').click(function () {
                //Grab upload container
                var cardContent = $(this).closest(".submit-docs-card-content");
                var myUploadDivs = cardContent.find('.upload-body').first();
                fileCount++;
                //Create an input control
                var newUploadControl = '<div class="upload-contents upload-contents-hidden" id="' + fileCount + '"><div class="row upload-container"><div class="col-6 file-browser"><span class="document-uploading"></span><span class="file-name">Browse for a file</span><i class="fas fa-trash-alt cancelUpload"></i></div><input type="file" class="soon-to-be-uploaded hiddenInput" accept=".bmp,.doc,.docx,.heic,.heif,.jpeg,.jpg,.msg,.pdf,.png,.tif,.tiff,.xls,.xlsx" /></div></div>';

                myUploadDivs.append(newUploadControl);

                //Grab most recent contol
                var newFile = cardContent.find(".soon-to-be-uploaded").last();

                //When user picks a file, populate the name field of it, and then show it to the user
                newFile.on('change', function () {
                    addTofileInfoUploadQueue(this.files[0], $(this));
                });

                //Click that invisible input
                newFile.click();
            });

            $(document).on('click', '#saveSelectedDocument', function () {
                var documentId = $('.select-document:checked').first().val();
                var cardContent = uploadCardContent;
                var myUploadDivs = cardContent.find('.upload-body').first();
                fileCount++;
                //Create an input control
                var newUploadControl = '<div class="upload-contents upload-contents-hidden" id="' + fileCount + '"><div class="row upload-container"><div class="col-6 file-browser"><span class="document-uploading"></span><span class="file-name">Browse for a file</span><i class="fas fa-trash-alt cancelUpload"></i></div><input type="file" class="soon-to-be-uploaded hiddenInput" accept=".bmp,.doc,.docx,.heic,.heif,.jpeg,.jpg,.msg,.pdf,.png,.tif,.tiff,.xls,.xlsx" /></div></div>';

                myUploadDivs.append(newUploadControl);
                var newFile = cardContent.find(".soon-to-be-uploaded").last();
                attachExistingFileToDependent(documentId, newFile, fileCount);
            })

            $('.toggle-sections').click(function () {
                if ($(this).children('.fas').hasClass('fa-angle-up')) {
                    $(this).children('.fas').removeClass('fa-angle-up').addClass('fa-angle-down');
                    $(this).children('.toggle-sections-text').html('View Options');
                    $(this).closest('.submit-docs-card').find('.section').hide();
                }
                else {
                    $(this).children('.fas').removeClass('fa-angle-down').addClass('fa-angle-up');
                    $(this).children('.toggle-sections-text').html('Hide Options');
                    $(this).closest('.submit-docs-card').find('.section').show();
                }
            })

            //Deleting queued documents
            $(document).on('click', '.cancelUpload', function (event) {
                event.preventDefault();
                var cardContent = $(this).closest(".submit-docs-card-content");

                var fileNum = $(this).closest('.upload-contents').attr("id");
                var index = fileInfoUploadQueue.indexOf(parseInt(fileNum));
                if (index !== -1) {
                    fileInfoUploadQueue.splice(index, 1);
                }
                $(this).closest('.upload-contents').remove();

                const fileError = $(`#file-error-${fileNum}`).remove();
                if (fileError > 0) {
                    fileError.remove();
                }

                if (cardContent.find(".upload-contents").length == 0) {
                    cardContent.find(".upload-collapse").first().collapse("hide");
                    cardContent.find(".no-docs").first().show();
                }
            });

            //Deleting uploaded documents
            $(document).on('click', '.deleteUpload', function (event) {
                event.preventDefault();
                deleteFile($(this).closest('.upload-container'));
            });

            $(document).on('click', '.deleteFileFromAzure', function (event) {
                event.preventDefault();
                deleteFileFromAzure($(this).closest('.upload-container'));
            });

            $(document).on('click', '.file-name', function () {
                var fileNum = $(this).closest('.upload-contents').attr("id");
                if ($(`#file-error-${fileNum}`).length === 0) {
                    const documentId = $(this).closest('.upload-container').data('document-id');
                    getDocumentUrl(documentId).then((url) => {
                        window.open(url, "_blank");
                    });
                }
            });

            $('.existing-documents-link').click(function () {
                uploadCardContent = $(this).closest('.submit-docs-card-content');

                // Get docIds already attached to this section and docType
                const attachedDocIds = [];
                const uploadContainers = uploadCardContent.find('.upload-container');
                uploadContainers.each(function () {
                    attachedDocIds.push($(this).data('document-id'));
                });

                // Hide any docs that are already in the attached docIds, and show the rest
                const documentContainers = $('#addExistingDocumentModal').find('.select-document-container');
                documentContainers.each(function (index, element) {
                    const existingDocuments = $(this).children('.select-document');
                    existingDocuments.each(function () {
                        if (this.checked) {
                            this.checked = false;
                        }

                        if (attachedDocIds.includes(this.id)) {
                            $(element).hide();
                        } else {
                            $(element).show();
                        }
                    });
                });

                $('#imagePreview').hide();
                $('#pdfPreview').hide();
                $('#fileNotSupported').hide();
                $('#textPreview').show();
                $("#addExistingDocumentModal").modal('show');
            });

            $("#submission-text > div").hide();
            $("#toggle-email-submission-text").click(function () {
                $("#submission-text > div").hide();
                $("#email-submission-text").show();
            });

            $("#toggle-fax-submission-text").click(function () {
                $("#submission-text > div").hide();
                $("#fax-submission-text").show();
            });

            $("#toggle-mail-submission-text").click(function () {
                $("#submission-text > div").hide();
                $("#mail-submission-text").show();
            });

            $('#openAlternateSubmissionsModal').click(function () {
                $("#alternateSubmissionsModal").modal('show');
            });

            $('#proofOfLifeEventModalLink').click(function () {
                $("#proofOfLifeEventModal").modal('show');
            });

            initialized = true;
        }
    }
})();